module.exports = __webpack_public_path__ + "img/112.2f875fa7.svg";